
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return-policy",
      function () {
        return require("private-next-pages/return-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return-policy"])
      });
    }
  